import "./singleCategoryWeb.scss";
import { Translate } from "react-localize-redux";
import styled from "styled-components";
import { getMasterConfig } from "wallet-elementkit/dist/constants/master";
import BaseButton from "wallet-elementkit/dist/elementKit/baseButton/BaseButton";

const StyledCategoryWeb = styled.div`
	${(props) => `border-bottom: 1px solid ${props.primaryColor} !important;`}
`;
const SingleCategoryWeb = (props) => {
	const config = getMasterConfig();
	return (
		<StyledCategoryWeb
			id="issuer-profile-single-category-web"
			className="flex-row jc-sb"
			primaryColor={config.primaryColor}
			style={props.styles}
		>
			<div className="category-info flex-row">
				<span className="medium s5">{props.title}</span>
				<div className="divider-circle"></div>
				<span className="s7-5 passive-gray">
					<Translate
						id={props.count > 1 ? "totalCredentialsPlural" : "totalCredentials"}
						data={{ credentialCount: props.count }}
					/>
				</span>
			</div>
			{props.onClickAction && props.count ? (
				<BaseButton
					type="primary"
					size="small"
					height={35}
					loading={false}
					onClickAction={props.onClickAction}
				>
					<span className="s7-5">
						<Translate id="seeAll" />
					</span>
				</BaseButton>
			) : null}
		</StyledCategoryWeb>
	);
};

export default SingleCategoryWeb;
